/**
 * Bir metnin sadece ilk harfini büyütür.
 * @param {string} s - Formatlanacak metin
 * @param {string} locale - Dil seçeneği (Türkçe karakter uyumu için 'tr-TR' önerilir)
 * @returns {string} - Formatlanmış metin
 * capitalize("ahmet yılmaz")	"Ahmet yılmaz"
 * capitalize("İSTANBUL BOĞAZI")	"İstanbul BOĞAZI"
 * capitalize("javascript dünyası", "en-US")	"Javascript dünyası"
 */
export const capitalize = (s, locale = 'tr-TR') => 
  s && s.length > 0 && s[0].toLocaleUpperCase(locale) + s.slice(1).toLocaleLowerCase(locale)


/**
 * Bir metindeki her kelimenin ilk harfini büyütür.
 * @param {string} s - Formatlanacak metin
 * @param {string} locale - Dil seçeneği (Türkçe karakter uyumu için 'tr-TR' önerilir)
 * @returns {string} - Formatlanmış metin
 * capitalizeWords("ahmet yılmaz")	"Ahmet Yılmaz"
 * capitalizeWords("İSTANBUL BOĞAZI")	"İstanbul Boğazı"
 * capitalizeWords("javascript dünyası", "en-US")	"Javascript Dünyası"
 */
export const capitalizeWords = (s, locale = 'tr-TR') => {
  if (!s || s.length === 0) return ""

  return s
    .split(" ") // Metni boşluklardan ayırarak bir dizi (array) oluşturur
    .map(word => 
      word.charAt(0).toLocaleUpperCase(locale) + 
      word.slice(1).toLocaleLowerCase(locale),
    ) // Her kelimenin ilk harfini büyütür, kalanını küçültür
    .join(" ") // Kelimeleri tekrar boşlukla birleştirir
}

/**
 * Bir metni ters çevirir.
 * @param {string} s - Formatlanacak metin
 * @returns {string} - Formatlanmış metin
 * reverse("ahmet yılmaz")	"zamlı tehma"
 * reverse("İSTANBUL BOĞAZI")	"IZABO LUBNATSI"
 * reverse("javascript dünyası", "en-US")	"ısaynud tsipircavaj"
 */
export const reverse = s => s && s.split``.reverse().join``

/**
 * Telefon numarasını maskeler.
 * @param {string} value - Formatlanacak telefon numarası
 * @returns {string} - Formatlanmış metin
 * phoneMask("5551234567")	"0(555) 123 45 67"
 * phoneMask("555-123-45-67")	"0(555) 123 45 67"
 * phoneMask("+905551234567")	"0(555) 123 45 67"
 */
export const phoneMask = value => {
  if (!value) return ""
  
  // Sadece rakamları al (boşluk veya parantez varsa temizle)
  let cleaned = value.toString().replace(/\D/g, "")

  // Eğer başında 0 yoksa ekle (opsiyonel, TR formatı için)
  if (cleaned.length === 10) cleaned = "0" + cleaned

  // Maskeleme
  return cleaned.replace(
    /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/,
    "0($2) $3 $4 $5",
  )
}

export const phoneMask2 = value => {
  if (!value) return ""
  
  // Sadece rakamları al (boşluk veya parantez varsa temizle)
  let cleaned = value.toString().replace(/\D/g, "")

  // Eğer başında 0 yoksa ekle (opsiyonel, TR formatı için)
  if (cleaned.length === 10) cleaned = "0" + cleaned

  // Maskeleme
  return cleaned.replace(
    /^(\d{4})(\d{7})$/,
    "$1 $2",
  )
}


/**
 * IBAN numarasını maskeler.
 * @param {string} value - Formatlanacak IBAN numarası
 * @returns {string} - Formatlanmış metin
 * ibanMask("TR0000000000000000000000")	"TR00 0000 0000 0000 0000 00"
 * ibanMask("TR0000000000000000000000")	"TR00 0000 0000 0000 0000 00"
 */
export const ibanMask = value => {
  if (!value) return ""
  value = value.toString()
  
  return value
    .replace(/\s+/g, "")
    .toUpperCase()
    .replace(/(.{4})/g, "$1 ")
    .trim()
}

/**
 * Bir listedeki (array) nesnelerin içindeki value değerine göre label'ı döndürür.
 * @param {Array} list - İçinde {value, label} olan dizi
 * @param {*} value - Aranacak değer
 * @returns {string} - Bulunan etiketi veya değerin kendisini döndürür
 */
export const listTitle = (list, value) => {
  if (!list || value === null || value === undefined) return ""
  
  const item = list.find(x => x.value == value)

  return item ? item.label : value
}
